import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";
import {buildPath} from "../../utils";
import {useMediaQuery} from "@mui/system";
import theme from "../../constants/theme";

const PrivateRoute = () => {
    const auth = useAuth();
    //TODO implementare pagina accedi da desktop
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    if (isMobile) {
        return <Navigate to={buildPath("/")} />;
    }
    if (auth && (!auth.token || (auth.user && auth.user.role !== "OPERATOR")) && !auth.user) {
        return <Navigate to={buildPath("/operatore")} />;
    }
    return <Outlet />;
};

export default PrivateRoute;
